import React, { useState, useEffect, useRef } from "react";
import { AsyncPaginate, withAsyncPaginate, wrapMenuList } from 'react-select-async-paginate';
import Select, { CreatableSelect, AsyncPaginateSelect, AsyncSelect } from "./chakra-react-select";
import axios from 'axios';
import { useRouter } from 'next/router';
import { getPagination } from '../utils/getPagination'

// const CustomAsyncPaginate = withAsyncPaginate(AsyncPaginateSelect);

const fetcher = (url, token) =>
fetch(url, {
  method: 'GET',
  headers: new Headers({ 'Content-Type': 'application/json', token }),
  credentials: 'same-origin',
}).then((res) => res.json())

export const SelectAsyncPaginate = ({
  className,
  placeholder,
  field,
  form,
  options,
  isMulti,
  instanceId,
}) => {
  const router = useRouter();
  const shouldLoadMore = (scrollHeight, clientHeight, scrollTop) => {
    const bottomBorder = (scrollHeight - clientHeight) / 2;

    return bottomBorder < scrollTop;
  };

  const query = router.query.gene ? true: false

  useEffect(() => {
    if (!router.query.gene) {
      form.setFieldValue(
        field.name,
        []
      );
    }
    else {
      form.setFieldValue(
        field.name,
        typeof router.query.gene == 'object' ? router.query.gene.map((item) => item) : router.query.gene,
      );
    }
  }, [router]);
  
  const onChange = (option) => {
    form.setFieldValue(
      field.name,
      isMulti ? option.map((item) => item.value) : option.value,
    );
  };

  const getValue = () => {
    if (options) {
      return isMulti
          ? options.filter(function (option) { return field.value.indexOf(option.value) >= 0; })
          : options.find(function (option) { return option.value === field.value; });
  }
  else {
      return isMulti ? [] : "";
  }
  };

  async function loadOptions(search, loadedOptions, { page }) {
    var geneOptions = []

    const response = await axios.get(`/api/genesFilter?search=${search}&page=${page}`)
    const genes = response.data.genes

    for (let i = 0; i < genes.length; ++i) {
      geneOptions.push({'value': genes[i].slug.toLowerCase(), 'label': genes[i].symbol})
      if (!options.find(o => o.value === genes[i].slug.toLowerCase())) {
        options.push({
          value: genes[i].slug.toLowerCase(),
          label: genes[i].symbol
      })
    }
  }

    return {
      options: geneOptions,
      hasMore: page < genes.length,
      additional: {
        page: page + 1,
      },
    };
  }

  return (
    <AsyncPaginateSelect
      className={className}
      name={field.name}
      value={getValue()}
      onChange={onChange}
      placeholder={placeholder}
      options={options}
      loadOptions={loadOptions}
      shouldLoadMore={shouldLoadMore}
      defaultOptions
      additional={{
        page: 1,
      }}
      isMulti={isMulti}
      closeMenuOnSelect={false}
      isSearchable={true}
      cacheUniqs={[options]}
      instanceId={instanceId}
    />
  );
};

export default SelectAsyncPaginate;
